import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CuestionariosService } from '../services/cuestionarios.service';

@Component({
  selector: 'app-nuevo-script-dialog',
  templateUrl: './nuevo-script-dialog.component.html',
  providers: [MessageService]
})
export class NuevoScriptDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() cuestionario: any = null;
  @Input() preguntaSeleccionada: any = null;
  @Input() scriptSeleccionado: any = null;
  @Input() opcionSeleccionada: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();

  form: FormGroup;
  loading: boolean = false;
  esEdicion: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {
    this.form = this.fb.group({
      iNumScript: ['', [Validators.required]],
      sComentario: ['', [Validators.required]]
    });
  }

  get iNumOpcionMostrada(): number | string {
    return this.scriptSeleccionado?.iNumOpcion ?? this.opcionSeleccionada?.iNumOpcion ?? '';
  }

  ngOnInit(): void {
    this.cargarDatosIniciales();
    if (this.scriptSeleccionado) {
      this.cargarDatosScript();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scriptSeleccionado'] || changes['opcionSeleccionada'] || changes['displayDialog']) {
      this.esEdicion = !!this.scriptSeleccionado;
      this.cargarDatosIniciales();
      if (this.scriptSeleccionado) {
        this.cargarDatosScript();
      }
    }
  }

  cargarDatosIniciales(): void {
    if (this.esEdicion && this.scriptSeleccionado) {
      this.form.patchValue({
        iNumScript: this.scriptSeleccionado.iNumScript,
        sComentario: this.scriptSeleccionado.sComentario
      });
      this.form.get('iNumScript')?.disable();
    } else {
      this.form.reset();
      this.form.get('iNumScript')?.enable();
    }
  }

  cargarDatosScript(): void {
    if (this.scriptSeleccionado) {
      const request = {
        que: 5,
        tope: "",
        sClaveCues: this.cuestionario.sClaveCues,
        iNumPreg: this.preguntaSeleccionada.iNumPreg,
        iNumOpcion: this.scriptSeleccionado.iNumOpcion,
        iNumScript: this.scriptSeleccionado.iNumScript,
        sComentario: ""
      };
      this.loading = true;
      this.cuestionariosService.getScripts(request).subscribe({
        next: (response) => {
          if (response.success && response.data.length > 0) {
            const script = response.data[0];
            this.form.patchValue({
              iNumScript: script.iNumScript,
              sComentario: script.sComentario
            });
          }
        },
        error: (error) => {
          console.error('Error al cargar datos del script:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los datos del script'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formValue = this.form.getRawValue();
    const request = {
      que: this.esEdicion ? 2 : 1,
      tope: "",
      sClaveCues: this.cuestionario.sClaveCues,
      iNumPreg: this.preguntaSeleccionada.iNumPreg,
      iNumOpcion: this.iNumOpcionMostrada,
      iNumScript: formValue.iNumScript,
      sComentario: formValue.sComentario
    };

    this.cuestionariosService.guardarScript(request).subscribe({
      next: (response) => {
        if (response.success && response.data.error === "0") {
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: this.esEdicion ? 'Script actualizado correctamente' : 'Script creado correctamente'
          });
          this.displayDialog = false;
          this.displayDialogChange.emit(this.displayDialog);
          this.onHide.emit({ refresh: true });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo guardar el script'
          });
        }
      },
      error: (error) => {
        console.error('Error al guardar script:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Ocurrió un error al guardar el script'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }
} 